import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SecurityService } from '../../../shared/services/security.service';
import { Router } from '@angular/router';
import { Subscription, from } from 'rxjs';
import { fadeIn } from '../../utils/app-animation';
import { MenuService } from 'src/app/shared/services/menu.service';
import * as debug from '../../../shared/services/debug.service';

@Component({
	selector: 'app-user-menu',
	templateUrl: './user-menu.component.html',
	styleUrls: ['./user-menu.component.scss'],
	encapsulation: ViewEncapsulation.None,
	animations: [fadeIn],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserMenuComponent implements OnInit, OnDestroy {
	private subcriptions = new Subscription();

	isLoggedIn = false;
	@Input() profilePic: string;

	constructor(private readonly securityService: SecurityService, public router: Router, public menuService: MenuService, private cdr: ChangeDetectorRef) {
		// this.subcriptions.add(this.securityService.loginChanged.subscribe(loggedIn => {
		//     debug.log(`074 UserMenuComponent loggedIn: ${loggedIn}`);
		//     this.isLoggedIn = loggedIn;
		// }));
		debug.log(`074 UserMenuComponent instantiated`);

		this.securityService.loginChanged.subscribe(loggedIn => {
			debug.log(`074.1 UserMenuComponent loggedIn: ${loggedIn}`);
			this.isLoggedIn = loggedIn;
			this.cdr.detectChanges();
		});
	}

	ngOnInit() {
	}

	login() {
		from(this.securityService.login()).subscribe();
	}

	logout() {
		this.securityService.logout();
	}

	ngOnDestroy(): void {
		this.subcriptions.unsubscribe();
	}

	setActiveModule() {
		this.menuService.setActiveModule('/profile', `UserMenuComponent.setActiveModule`);
	}
}
